import React, { Component } from "react";
import moment from "moment";
import { Modal, DatePicker, Row, Col, Alert } from "antd";
import { ClockCircleOutlined } from "@ant-design/icons";
import { ButtonItem } from "../../../../Components/Items";
import "../cmms.css";

// Lo primero al abrir una Orden de Servicio en curso que aún no tiene término: cuándo empezó y
// cuándo terminó el servicio (casi siempre se captura después de hacerlo). Llena los campos
// Inicio y Término del formulario; se guardan con el servicio.
// props: visible, inicio, termino (ISO o null), onAceptar(inicio: moment, termino: moment | null), onMasTarde()
class ModalFechasServicioCMMS extends Component {
    state = { inicio: null, termino: null };

    componentDidUpdate(prev) {
        if (this.props.visible && !prev.visible) this.setState({ inicio: this.props.inicio ? moment(this.props.inicio) : moment(), termino: this.props.termino ? moment(this.props.termino) : null });
    }

    render() {
        const { visible, onMasTarde, onAceptar } = this.props;
        const { inicio, termino } = this.state;
        const error = inicio && termino && termino.isBefore(inicio) ? "El término no puede ser antes del inicio." : null;
        const ahora = (campo) => (
            <ButtonItem type="link" size="small" htmlType="button" lessTime onClick={() => this.setState({ [campo]: moment() })} style={{ padding: 0 }}>
                Ahora
            </ButtonItem>
        );
        return (
            <Modal
                className="cmms-modal"
                visible={visible}
                onCancel={onMasTarde}
                maskClosable={false}
                width={window.innerWidth > 640 ? 580 : "96%"}
                title={
                    <div className="cmms-modal-titulo">
                        <ClockCircleOutlined style={{ fontSize: 20, color: "#2fb8d6" }} />
                        <div>
                            <div className="cmms-modal-titulo-texto">¿Cuándo fue el servicio?</div>
                            <div className="cmms-modal-subtitulo">Fecha y hora en que empezó y en que terminó. Salen en la Orden, en su PDF y en la duración.</div>
                        </div>
                    </div>
                }
                footer={
                    <div className="cmms-modal-pie" style={{ padding: 0, border: 0 }}>
                        <span className="cmms-modal-pie-nota">Se guardan con el servicio.</span>
                        <ButtonItem type="default" htmlType="button" onClick={onMasTarde}>
                            Más tarde
                        </ButtonItem>
                        <ButtonItem type="primary" htmlType="button" disabled={!inicio || !!error} onClick={() => onAceptar(inicio, termino)}>
                            Listo
                        </ButtonItem>
                    </div>
                }
            >
                <div className="cmms-modal-cuerpo">
                    <Row gutter={14}>
                        <Col xs={24} sm={12}>
                            <div className="cmms-etiqueta-campo" style={{ display: "flex", justifyContent: "space-between" }}>
                                Inicio {ahora("inicio")}
                            </div>
                            <DatePicker
                                showTime={{ format: "HH:mm" }}
                                format="DD/MM/YYYY HH:mm"
                                allowClear={false}
                                size="large"
                                style={{ width: "100%" }}
                                value={inicio}
                                onChange={(v) => v && this.setState({ inicio: v })}
                            />
                        </Col>
                        <Col xs={24} sm={12}>
                            <div className="cmms-etiqueta-campo" style={{ display: "flex", justifyContent: "space-between" }}>
                                Término {ahora("termino")}
                            </div>
                            <DatePicker
                                showTime={{ format: "HH:mm" }}
                                format="DD/MM/YYYY HH:mm"
                                size="large"
                                placeholder="Aún no termina"
                                style={{ width: "100%" }}
                                value={termino}
                                onChange={(v) => this.setState({ termino: v || null })}
                            />
                        </Col>
                    </Row>
                    {error && <Alert type="error" showIcon style={{ marginTop: 10 }} message={error} />}
                    <div className="cmms-ayuda" style={{ marginTop: 10 }}>
                        Si aún no termina, deje el término vacío: se vuelve a preguntar al abrirla y, si se concluye sin término, se usa la hora en que se concluye.
                    </div>
                </div>
            </Modal>
        );
    }
}

export default ModalFechasServicioCMMS;
